export class RHNumberInputValidation {

    static numericValueFromTextWithinRange(
        text: string,
        allowsDecimals: boolean,
        minimumValue?: number,
        maximumValue?: number
    ): number | undefined {
        const normalizedText = text.trim().replace(",", ".")
        let numberPattern = /^-?\d+$/
        if (allowsDecimals) {
            numberPattern = /^-?\d+(?:\.\d+)?$/
        }
        if (!numberPattern.test(normalizedText)) {
            return undefined
        }

        const numericValue = Number(normalizedText)
        if (!Number.isFinite(numericValue)) {
            return undefined
        }
        if (minimumValue !== undefined && numericValue < minimumValue) {
            return undefined
        }
        if (maximumValue !== undefined && numericValue > maximumValue) {
            return undefined
        }
        return numericValue
    }

    static isValidNumberTextWithinRange(
        text: string,
        allowsDecimals: boolean,
        minimumValue?: number,
        maximumValue?: number
    ): boolean {
        return RHNumberInputValidation.numericValueFromTextWithinRange(
            text,
            allowsDecimals,
            minimumValue,
            maximumValue
        ) !== undefined
    }

}
